import { MilkFactory } from './milkFactory';

import type {
  MilkEntity,
  MilkPropsPub,
  MilkPropsPvt,
} from './milkEntity';
import type { MilkIRepository } from './milkIRepository';
import type { EntityDataPubType } from '@/infra/appsync';
import type { MilkJsonPub, MilkJsonPvt } from '@/types/domain/milk/entities/milkEntity';

import { AppsyncRepository } from '@/domain/appsyncRepository';
import {
  EntityName,
} from '@/infra/appsync';

export class MilkRepository extends AppsyncRepository<
  MilkEntity,
  MilkPropsPvt,
  MilkJsonPvt,
  MilkPropsPub,
  MilkJsonPub
> implements MilkIRepository {
  private factory = new MilkFactory();

  protected get entityName(): EntityName {
    const name: EntityName = EntityName.WagakoAppMilkMilkEntity;
    return name;
  }

  /**
   * DBデータをEntityに変換
   * @param props DBデータ
   * @returns Entity
   */
  protected createFromEntityType = (
    props: EntityDataPubType,
  ) => this.factory.createFromEntityType(props);
}
